import Swal from "sweetalert2";

const defaultTime = 2500;

const swalSuccess = (message, options = {}) => {
  const parsedOptions = typeof options === "string" ? { title: options } : options;
  Swal.fire({
    icon: "success",
    title: parsedOptions.title || "Success!",
    text: message,
    timer: parsedOptions.timer || defaultTime,
    timerProgressBar: parsedOptions.timerProgressBar ?? true,
    showConfirmButton: parsedOptions.showConfirmButton ?? false,
    ...parsedOptions,
  });
};

const swalError = (message, options = {}) => {
  const parsedOptions = typeof options === "string" ? { title: options } : options;
  const config = {
    icon: "error",
    title: parsedOptions.title || "Error!",
    timer: parsedOptions.timer || defaultTime,
    timerProgressBar: parsedOptions.timerProgressBar ?? true,
    showConfirmButton: parsedOptions.showConfirmButton ?? false,
    ...parsedOptions,
  };

  // Use html property if html option is true, otherwise use text
  if (parsedOptions.html) {
    config.html = message;
  } else {
    config.text = message;
  }

  Swal.fire(config);
};

const swalWarning = (message, options = {}) => {
  const parsedOptions = typeof options === "string" ? { title: options } : options;
  Swal.fire({
    icon: "warning",
    title: parsedOptions.title || "Warning!",
    text: message,
    timer: parsedOptions.timer || defaultTime,
    timerProgressBar: parsedOptions.timerProgressBar ?? true,
    showConfirmButton: parsedOptions.showConfirmButton ?? false,
    ...parsedOptions, // Spread to allow full customization
  });
};

const swalConfirm = (
  title,
  text,
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
  showCloseButton = false,
) => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  const safeConfirmText = confirmButtonText || "Confirm";
  const safeCancelText = cancelButtonText || "Cancel";

  const confirmHtml = isMobile
    ? safeConfirmText
    : `<span style="display:flex;align-items:center;gap:6px;">${safeConfirmText} <kbd style="background:rgba(255,255,255,0.2);padding:2px 6px;border-radius:4px;font-size:0.8em;font-family:inherit;border:1px solid rgba(255,255,255,0.3);">Enter ↵</kbd></span>`;

  const cancelHtml = isMobile
    ? safeCancelText
    : `<span style="display:flex;align-items:center;gap:6px;">${safeCancelText} <kbd style="background:rgba(0,0,0,0.1);padding:2px 6px;border-radius:4px;font-size:0.8em;font-family:inherit;border:1px solid rgba(0,0,0,0.15);">Esc</kbd></span>`;

  return Swal.fire({
    icon: "warning",
    title,
    text,
    showCancelButton: true,
    showCloseButton,
    focusConfirm: true,
    allowEnterKey: true,
    customClass: showCloseButton ? { closeButton: "swal-close-btn" } : {},
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: confirmHtml,
    cancelButtonText: cancelHtml,
    didOpen: () => {
      const confirmBtn = Swal.getConfirmButton();
      if (confirmBtn) {
        confirmBtn.focus();
      }

      const popup = Swal.getPopup();
      if (popup) {
        popup.addEventListener("keydown", (e) => {
          // Disable switching buttons using Tab
          if (e.key === "Tab") {
            e.preventDefault();
            return;
          }

          // Enter simply clicks confirm since tab is blocked
          if (e.key === "Enter") {
            e.preventDefault();
            if (confirmBtn) {
              confirmBtn.click();
            }
          }
        });
      }
    },
  });
};

const swalToast = (messageOrOptions, icon = "success", options = {}) => {
  const isObject = typeof messageOrOptions === "object" && messageOrOptions !== null;
  const config = isObject
    ? messageOrOptions
    : {
        title: messageOrOptions,
        icon: typeof icon === "string" ? icon : "success",
        ...(typeof options === "string" ? { title: options } : options),
      };

  return Swal.fire({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    showClass: {
      popup: "swal-toast-in",
    },
    hideClass: {
      popup: "swal-toast-out",
    },
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
    ...config,
  });
};
swalToast.fire = swalToast;

export { swalSuccess, swalError, swalWarning, swalConfirm, swalToast };
